"use strict";

class SalesApplicationController {
    constructor(
        $scope,
        $window,
        $filter,
        SSUserService,
        SSAppService,
        SSHttpService,
        SSUtilService,
        SSDateService,
        SSAlertService,
        $timeout,
        SSConfigService,
        NgTableParams,
        SSConfirmationService,
        SSAnalyticsService,
        SSLockService,
        SSSaleChangeFeedService
    ) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.SSLockService = SSLockService;
        self.SSSaleChangeFeedService = SSSaleChangeFeedService;
        self.SSUserService = SSUserService;
        self.SSAppService = SSAppService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAlertService = SSAlertService;
        self.SSAnalyticsService = SSAnalyticsService;
        self.$timeout = $timeout;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;
        self.data = SHOWSUITE.data;
        self.filter = $filter;
        self.NgTableParams = NgTableParams;
        self.parameters = self.data.url_param;

        self.SALE_STATUS_DRAFT = SHOWSUITE.SALE_STATUS_DRAFT;
        self.SALE_STATUS_PENDING = SHOWSUITE.SALE_STATUS_PENDING;
        self.SALE_STATUS_SUBMITTED = SHOWSUITE.SALE_STATUS_SUBMITTED;
        self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
        self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
        self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
        self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;

        self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT;
        self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW;
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED;
        self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;
        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;

        self.SALE_STATUS_CHEQUE_ENTERED = SHOWSUITE.SALE_STATUS_CHEQUE_ENTERED;
        self.SALE_STATUS_SPA_ENTERED = SHOWSUITE.SALE_STATUS_SPA_ENTERED;
        self.SALE_STATUS_EXPIRED = SHOWSUITE.SALE_STATUS_EXPIRED;
        self.SALE_STATUS_EXTENDED = SHOWSUITE.SALE_STATUS_EXTENDED;
        self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
        self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;
        self.SALE_STATUS_INVALID = SHOWSUITE.SALE_STATUS_INVALID;
        self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;
        self.SALE_STATUS_DELETED = SHOWSUITE.SALE_STATUS_DELETED;

        self.BROKER_ROLE_MAIN_BROKER = SHOWSUITE.BROKER_ROLE_MAIN_BROKER;
        self.BROKER_ROLE_TEAMLEAD = SHOWSUITE.BROKER_ROLE_TEAMLEAD;
        self.BROKER_ROLE_SALES_CONSULTANT = SHOWSUITE.BROKER_ROLE_SALES_CONSULTANT;

        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED =
            SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;
        self.PROPERTY_DOCUMENT_KIND_SPA_LETTER =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_SPA_LETTER;
        self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;

        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_PDI_FORM =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM;
        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_AML = SHOWSUITE.PROPERTY_DOCUMENT_KIND_AML;
        self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT;
        self.PROPERTY_DOCUMENT_KIND_ANNEXES =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEXES;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_A =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_A;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_B3 =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_B3;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_C =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_C;
        self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_SIDE_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM;
        self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT;

        /**
         * `include` of the listing request. WEB-4686: the change feed is asked for
         * the same include so the rows it returns match the list's own rows.
         */
        self.SALES_LIST_INCLUDE = "eois, properties, units, brokers, agencies, sale_buyers, question_answers, documents, history, payments, sale_gst_detail, payment_plans, property_settings, aml_scans_modified";

        /** Sequence of listing requests; only the latest may fill the table. */
        self.list_request_id = 0;

        /**
         * WEB-4686: silent refresh from the sales change feed (replaces the old
         * 10-second `response_md5` reload of the whole list).
         */
        self.saleChangePoller = SSSaleChangeFeedService.createPoller({
            scope: $scope,
            getParams: function () {
                return {
                    property_id: self.property_id,
                    include: self.SALES_LIST_INCLUDE,
                };
            },
            onChanges: function (data) {
                self.applySaleChanges(data);
            },
        });

        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL;
        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS;
        self.QUESTION_MARKER_SPECIAL_CONDITIONS = SHOWSUITE.QUESTION_MARKER_SPECIAL_CONDITIONS;

        self.LOCK_TYPE_SALE_APPLICATION_REVIEW =
            SHOWSUITE.LOCK_TYPE_SALE_APPLICATION_REVIEW;
        self.LOCK_TYPE_SALE_GENERATE_OTP =
            SHOWSUITE.LOCK_TYPE_SALE_GENERATE_OTP;

        self.PAYMENT_TYPE_01_BOOKING_FEE =
            SHOWSUITE.PAYMENT_TYPE_01_BOOKING_FEE;

        self.otp_documents = [
            {
                id: null,
                name: "Default",
            },
        ];
        self.spa_documents = [
            {
                id: null,
                name: "Default",
            },
        ];

        self.developer_users = [];
		self.developerUser = null;

        // WEB-4375: `lock_name` of the OTP-generation lock currently held by
        // this controller, as returned by the unified acquire. Null whenever
        // the Generate OTP popup is closed or no lock was taken.
        self.otp_lock_name = null;

        self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER =
            SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER;

        //self.resetEmailObject();

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        // Trigger View Event for Sales Application Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_APPLICATIONS,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.pagination = {
            current: 1,
        };

        self.booking_fee_percentage = 5;

        if (!self.search_by || self.search_by == "undefined") {
            sessionStorage.setItem("search_by_filter", "unit_no");
        }
        self.property_id = sessionStorage.getItem("property_id_filter");
        self.sale_status = sessionStorage.getItem("sale_status_filter");
        self.price = sessionStorage.getItem("price_filter");
        self.agency = sessionStorage.getItem("agency_filter");
        self.broker = sessionStorage.getItem("broker_filter");
        self.buyer = sessionStorage.getItem("buyer_filter");
        self.search_by = sessionStorage.getItem("search_by_filter");
        self.search_value = sessionStorage.getItem("search_value_filter");
        self.sortColumn = sessionStorage.getItem("sort_column_filter");
        self.sortOrder = sessionStorage.getItem("sort_order_filter");
        self.limit = sessionStorage.getItem("limit_filter");
        self.property_documents = null;

        if (self.property_id) {
            self.property_id = parseInt(self.property_id);
        }

        if (self.sale_status) {
            self.sale_status = parseInt(self.sale_status);
        }
        if (!self.parameters.id) {
            self.current = 1;
        } else {
            self.current = self.parameters.id;
        }

        self.prepareSortByValues();

        self.pageChanged = function (newPage) {
            self.retrieveApplications(newPage);
            //\location.replace('/payments?id=' + self.current);
            if (history.pushState) {
                window.history.replaceState(
                    "object or string",
                    "Title",
                    "applications?id=" + self.current
                );
            } else {
                document.location.href = "applications?id=" + self.current;
            }
        };

        $("#otpDatepicker").datepicker({ dateFormat: "dd/mm/yy" });
        $("#otpDatepickerTwo").datepicker({ dateFormat: "dd/mm/yy" });
        self.otp_date = moment().format("DD/MM/YYYY");
        self.application_page = true;
        self.sales = [];
        self.select_property_id = "";
        self.select_otp_date_from = "";
        self.select_otp_date_to = "";
        self.projects = [];
        self.limit = 10;
        self.offset = 0;
        self.sales_total = 0;

        //self.order_by = '{"otp_date": "desc"}';
        self.sortColumn = "otp_date";
        self.sortOrder = "asc";

        self.prepareDeveloperProperties();
        self.prepareSaleStatuses();
        self.countries = self.SSConfigService.getCountries();

        // Calendar
        $(".datepicker").datepicker({ dateFormat: "dd/mm/yy" });
    }

    prepareDeveloperProperties() {
        const self = this;

        let url = "sec/developer/properties/list";
        let params = {
            status: '30,50', // Approved, Listed
            'include': 'property_documents',
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.properties = response.data.properties;
            self.properties = self.properties.sort(function(a, b) {
                return b.id - a.id; // descending by id
            });
            if(self.properties && self.properties.length){
                const savedPropertyId = self.SSUtilService.getFromLocalStorage('lastPropertyId');
                if (savedPropertyId && self.properties.some(p => p.id == savedPropertyId)) {
                    self.property_id = savedPropertyId;
                } else {
                    self.property_id = parseInt(self.properties[0].id);
                    self.SSUtilService.saveToLocalStorage("lastPropertyId", self.property_id);
                }
            }
            self.$timeout(function () {
                $("select.dashboard-select#property-select").niceSelect(
                    "update"
                );
            });

            self.retrieveApplications(self.current);
			self.getDeveloperUsers();
        });
    }

    displayControls(index, sale) {
        const self = this;
        self.selected_sale = sale;
        var property_id = self.selected_sale.unit.property_id;
        $.each(self.properties, function (i, e) {
            if (e.id == property_id) {
                self.property_documents = e.property_documents;
            }
        });

        self.getOtpDocs();
        if (sale.property_settings.opt_spa == "OTP")
            self.selected_otp_document = self.otp_documents[0].id;
        if (sale.property_settings.otp_spa == "SPA")
            self.selected_otp_document = self.spa_documents[0].id;

        let close = true;
        if ($("#control_" + index).hasClass("show")) {
            close = false;
        }

        $(".controls").removeClass("show");

        if (close) {
            $("#control_" + index).toggleClass("show");
        }
    }

    getPsfValue(sale) {
        const self = this;

        let psf = "--";

        if (!sale) {
            return psf;
        }

        if (sale && sale.unit) {
            psf = self.SSAppService.getFormattedAmountWithDecimal(
                sale.price / sale.unit.size_ft2, sale.property.country
            );
        }

        return psf;
    }

    canGenerateAML(sale) {
        const self = this;

        if (!sale) {
            return false;
        }

        if (
            sale.status == self.SALE_STATUS_VERIFIED ||
            sale.status == self.SALE_STATUS_APPROVED ||
            sale.status == self.SALE_STATUS_OTP ||
            sale.status == self.SALE_STATUS_SPA_ENTERED ||
            sale.status == self.SALE_STATUS_EXTENDED
        ) {
            return true;
        } else {
            return false;
        }
    }

    regenerateAmlCft(sale) {
        const self = this;

        let url = "sec/developer/sales/" + sale.id + "/re-generate-aml";

        loading(true);
        self.SSHttpService.postAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (
                    response.sub_code == 305015 ||
                    response.sub_code == 412002
                ) {
                    self.SSAlertService.danger(
                        "Please Note:",
                        "This sale has been updated by another user. You will not be able to make further updates to this sale."
                    );
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.retrieveApplications();
            self.SSAlertService.success(
                "Success!",
                "AML generated successfully."
            );
        });
    }

    getOtpDocs() {
        const self = this;
        self.otp_documents = [];
        self.spa_documents = [];

        if (!self.property_documents) {
            self.otp_documents = [
                {
                    id: null,
                    name: "Default",
                },
            ];
            self.spa_documents = [
                {
                    id: null,
                    name: "Default",
                },
            ];
            return;
        }

        $.each(self.property_documents, function (i, e) {
            if (
                e.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP &&
                e.is_enabled
            ) {
                //self.otp_documents = $.extend({},self.otp_documents,e);
                self.otp_documents.push(e);
            }
            if (
                e.document_kind == self.PROPERTY_DOCUMENT_KIND_SPA_LETTER &&
                e.is_enabled
            ) {
                self.spa_documents.push(e);
            }
        });

        if (self.otp_documents.length == 0) {
            self.otp_documents = [
                {
                    id: null,
                    name: "Default",
                },
            ];
        }
        if (self.spa_documents.length == 0) {
            self.spa_documents = [
                {
                    id: null,
                    name: "Default",
                },
            ];
        }
    }

    prepareSortByValues() {
        const self = this;

        self.sort_by_values = [
            {
                id: "otp_no",
                name: "OTP NO",
            },
            {
                id: "otp_date",
                name: "OTP Date",
            },
            {
                id: "updated_at",
                name: "Date Updated",
            },
            {
                id: "status",
                name: "Status",
            },
        ];

        self.$timeout(function () {
            $("select.dashboard-select#sortby-select").niceSelect("update");
        });
    }

    exportApplications() {
        const self = this;

        let url = "sec/developer/sales/application-export";
        let params = {
            status: "12,20,21,30,31,32,34,35,37,50",
            property_id: self.select_property_id,
            otp_date_from: self.select_otp_date_from,
            otp_date_to: self.select_otp_date_to,
        };

        url = self.SSHttpService.getApiURL(url);
        url += url.indexOf("?") === -1 ? "?" : "&";
        url += $.param(params);
        self.$window.location.href = url;

        self.hideModals();
        self.showExport = false;
        self.SSAlertService.success(
            "Success!",
            "Sales application export successfully."
        );
    }

    openExportSaleApplication() {
        const self = this;
        self.hideModals();
        self.showExport = true;
        $("#developerSaleApplicationExportModal").modal("show");
    }

    onAcceptConfirm() {
        const self = this;

        self.hideModals();
        let url = "sec/developer/sales/" + self.selected_sale.id + "/status";
        let params = {
            status: self.SALE_STATUS_APPROVED,
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.selected_sale.status = self.SALE_STATUS_APPROVED;
            self.SSAlertService.success(
                "Success!",
                "Sale is approved successfully."
            );

            self.showOTPModal = true;
            $("#developerSaleApplicationOTPModal").modal("show");
        });
    }

    onOTP() {
        const self = this;

        self.hideModals();

        self.showOTPModal = true;
        $("#developerSaleApplicationOTPModal").modal("show");
    }

    onRejectConfirm() {
        const self = this;

        let url = "sec/developer/sales/" + self.selected_sale.id + "/status";
        let params = {
            status: self.SALE_STATUS_REJECTED,
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.selected_sale.status = self.SALE_STATUS_REJECTED;
            self.SSAlertService.success(
                "Success!",
                "Sale is rejected successfully."
            );
        });
    }

    /**
     * Acquire the OTP-generation lock on a sale, then open the Generate OTP
     * popup.
     *
     * @remarks
     * WEB-4375: migrated from the legacy per-sale lock acquire endpoint to
     * the unified `sec/locks/acquire`. When the sale is already held by
     * someone else the user is offered the same "are you sure you want to
     * proceed?" confirmation as before, but proceeding now re-acquires with
     * `override: 1` instead of carrying on with no lock at all — the legacy
     * endpoints had no override, so the "yes" path used to leave the user
     * unprotected and the follow-up pings failing.
     *
     * @param {Object} sale Sale row from the applications listing.
     * @returns {void}
     */
    generateOTP(sale) {
        const self = this;

        self.acquireGenerateOTPLock(sale, 0);
    }

    /**
     * Acquire the OTP-generation lock and open the popup on success.
     *
     * @param {Object} sale     Sale row from the applications listing.
     * @param {number} override 1 to force-release a lock held by another user.
     * @returns {void}
     */
    acquireGenerateOTPLock(sale, override) {
        const self = this;

        loading(true);
        self.SSLockService.acquire(
            self.SSLockService.ENTITY_TYPE_SALE,
            sale.id,
            self.LOCK_TYPE_SALE_GENERATE_OTP,
            {override: override}
        ).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == self.SSLockService.SUB_CODE_LOCK_CONFLICT) {
                    self.SSConfirmationService.getConfirmed(
                        "Error!",
                        "This sale is being assessed by " +
                            self.SSLockService.getLockingUserName(response) +
                            ", are you sure you want to proceed?",
                        self.SSConfirmationService.TYPE_DEFAULT,
                        function () {
                            // Take the lock off the other user, then continue.
                            self.acquireGenerateOTPLock(sale, 1);
                        }
                    );
                } else if (response.sub_code == 305024) {
                    // The unified endpoint returns 305024 for every status
                    // that is not APPROVED, not just "OTP already generated".
                    self.SSAlertService.danger(
                        "Error!",
                        "This sale is not in a status where an OTP can be generated."
                    );
                } else if (response.sub_code == 305010) {
                    self.SSAlertService.danger("Error!", "Cannot find sale.");
                } else {
                    self.SSAlertService.parseAndDisplayServerError(response);
                }

                return;
            }

            self.otp_lock_name = response.data
                ? response.data.lock_name
                : self.SSLockService.getLockName(
                      self.SSLockService.ENTITY_TYPE_SALE,
                      sale.id,
                      self.LOCK_TYPE_SALE_GENERATE_OTP
                  );

            self.proceedToGenerateOTP(sale);
        });
    }

    proceedToGenerateOTP(sale) {
        const self = this;

        let booking_fee = {};
        self.currentSale = sale;
        self.actual_booking_fee = 0;
        self.selected_otp_document = null;

        jQuery.each(self.currentSale.payments, function (i, payments) {
            if (payments.type == self.PAYMENT_TYPE_01_BOOKING_FEE) {
                booking_fee = payments;
                return false;
            }
        });

        self.actual_booking_fee = booking_fee.due_amount;

        if (booking_fee.amount < booking_fee.due_amount) {
            $("#developerSaleApplicationBookingfeeAlertModal").modal("show");
            return;
        }

        self.otp_date = moment().format("DD/MM/YYYY");
		self.developerUser = null;
		self.developerUserError = null;

        /** WEB-2871 DMS: Generate OTP popup doesn't show Document's dropdown
         * Need to pre-select developerUser if only one in list **/
        if(self.developer_users && self.developer_users.length === 1 && self.developer_users[0].email){
            self.developerUser = [];
            self.developerUser[self.developer_users[0].email] = true
        }

        /** WEB-2918 DMS: OTP Date - Add permissions **/
        self.selected_property_id = sale.property_id;

        $("#developerSaleApplicationGenerateOTPModal").modal({
            show: true,
            backdrop: "static",
            keyboard: false,
        });
        self.pingGenerateOTPLock();
    }

    closeGenerateModal() {
        const self = this;

        self.releaseGenerateOTPLock("Generate OTP popup closed");
        self.hideModals();
    }

    /**
     * Heartbeat that keeps the OTP-generation lock alive while the popup is
     * open.
     *
     * @remarks
     * WEB-4375: pings the unified `sec/locks/{lockName}/ping` using the
     * `lock_name` returned by acquire. On any error the loop stops rather
     * than rescheduling — the lock is gone (1100002 / 1100003) or was taken
     * over by another user (1100001), and none of those recover by retrying.
     *
     * @returns {void}
     */
    pingGenerateOTPLock() {
        const self = this;

        if (!self.otp_lock_name) {
            return;
        }

        let lock_name = self.otp_lock_name;

        self.SSLockService.ping(lock_name).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayServerError(response);
                return;
            }

            // The popup may have been closed while this ping was in flight.
            if (self.otp_lock_name !== lock_name) {
                return;
            }

            // Auto refresh
            self.timeout_promise = self.$timeout(function () {
                self.pingGenerateOTPLock();
            }, 4 * 1000);
        });
    }

    /**
     * Stop the heartbeat and release the OTP-generation lock so the sale is
     * immediately available to other users.
     *
     * @remarks
     * WEB-4375: the legacy endpoints had no release and expired a lock after
     * 5 seconds, so abandoning the popup cleared the lock on its own. The
     * unified endpoints default to a 300-second expiry, so every exit from
     * the popup has to release explicitly. Safe to call when no lock is held
     * (the Regenerate OTP flow reuses this popup without taking one).
     *
     * @param {string} [reason] Free text stored on the lock audit trail.
     * @returns {void}
     */
    releaseGenerateOTPLock(reason) {
        const self = this;

        if (self.timeout_promise) {
            self.$timeout.cancel(self.timeout_promise);
            self.timeout_promise = null;
        }

        if (!self.otp_lock_name) {
            return;
        }

        self.SSLockService.release(self.otp_lock_name, reason);
        self.otp_lock_name = null;
    }

    /**
     * Re-open the Generate OTP popup for a sale whose OTP already exists.
     *
     * @remarks
     * WEB-2418 dropped the lock check from this flow, and WEB-4375 deleted the
     * commented-out legacy acquire it left behind. Regeneration deliberately
     * takes no lock, so `releaseGenerateOTPLock()` on the popup's exit paths
     * is a no-op here.
     *
     * @param {Object} sale Sale row from the applications listing.
     * @returns {void}
     */
    regenerateOTP(sale) {
        const self = this;

        self.proceedToRegenerateOTP(sale);
    }

    proceedToRegenerateOTP(sale) {
        const self = this;

        self.currentSale = sale;
        /** WEB-2918 DMS: OTP Date - Add permissions **/
        self.selected_property_id = sale.property_id;

        if (sale.documents && sale.documents.length > 0) {
            if (sale.property_settings.otp_spa == "OTP") {
                self.current_document = sale.documents.find(
                    (x) => x.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP
                );
            }
            if (sale.property_settings.otp_spa == "SPA") {
                self.current_document = sale.documents.find(
                    (x) =>
                        x.document_kind ==
                        self.PROPERTY_DOCUMENT_KIND_SPA_LETTER
                );
            }
            self.selected_otp_document = self.current_document
                ? self.current_document.property_document_id
                : null;
        }

        self.otp_date = moment(self.currentSale.otp_date).format("DD/MM/YYYY");
		self.developerUser = null;
		self.developerUserError = null;
        $("#developerSaleApplicationReGenerateOTPModal").modal({
            show: true,
            backdrop: "static",
            keyboard: false,
        });
        // Requirement changed: https://showsuite.atlassian.net/browse/WEB-2418
        // self.pingGenerateOTPLock(sale.id);
    }

    // RE-GENERATE OTP CASE
    onProceedReGenerateOTP(send_email, regenerate, sale) {
        const self = this;

        if (self.edit_otp_regenerate) {
            // Open OTP in editor
            self.$window.location.href =
                "/developer/sales/" + self.selected_sale.id + "/editotp";
        } else {
            self._generateOTP(send_email, regenerate, sale);
        }
    }

    // GENERATE OTP CASE
    onProceedGenerateOtp(send_email, regenerate, sale) {
        const self = this;

        if (self.edit_otp) {
            // Open OTP in editor
            self.$window.location.href =
                "/developer/sales/" + self.selected_sale.id + "/editotp";
        } else {
            self._generateOTP(send_email, regenerate, sale);
        }
    }

    _generateOTP(send_email, regenerate, sale) {
        const self = this;

        /** WEB-2811 AMS/DMS : AUS country support
         * Need to support SPA Signing by multiple developer users.
         * by allowing user to select multiple Developer Users when generating SPA **/
        let developerUserIdList = "";
        try{
            /** Get comma separated list of Selected Developer User Id(s) **/
            if(self.developerUser){
                developerUserIdList = self.developer_users
                    .filter(function (u) { return self.developerUser[u.email] })
                    .map( function(fu) { return fu.id })
                    .join();
            }
        }catch (e){
            console.error("An error occurred parsing Developer User list,")
        }

		if(sale.property_settings.otp_spa == "SPA" && !developerUserIdList){
			self.developerUserError = "Please Select a Developer";
			return;
		}
        let url = "sec/developer/sales/" + self.selected_sale.id + "/generate-otp";
		if(sale.property_settings.otp_spa == "SPA"){
			url = "sec/developer/sales/" + self.selected_sale.id + "/generate-spa";
		}
        let otp_utcFormat = self.SSDateService.formateWithTimeAsNoon(
            self.otp_date
        );

        // WEB-4375: the popup is done with the sale — stop the heartbeat and
        // hand the lock back before the (slow) generation request goes out.
        self.releaseGenerateOTPLock("OTP generated");

        let params = {
            send_email: send_email,
            otp_date: otp_utcFormat ? otp_utcFormat : null,
            document: self.selected_otp_document,
            regenerate: regenerate,
            timezone: self.SSDateService.getLocalTimezone()
        };
		if(sale.property_settings.otp_spa == "SPA"){
			params['developer_user_id'] = developerUserIdList;
		}

        // Requirement changed: WEB-1013
        // if (regenerate == false) {
        //   params["document"] = self.selected_otp_document;
        // }

        // if (self.selected_otp_document) {
        //   params["document"] = self.selected_otp_document;
        // }

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (
            response
        ) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (
                    response.sub_code == 305015 ||
                    response.sub_code == 412002
                ) {
                    self.SSAlertService.danger(
                        "Please Note:",
                        "This sale has been updated by another user. You will not be able to make further updates to this sale."
                    );
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.selected_sale.status = self.SALE_STATUS_OTP;
            sale.otp_date = otp_utcFormat ? otp_utcFormat : self.otp_date;

            let sale_document = response.data.sale_document;
            if (self.current_document && sale_document) {
                self.current_document.property_document_id =
                    sale_document.property_document_id;
            }
            self.selected_sale.documents.push(sale_document);

			if(sale.property_settings.otp_spa == "SPA"){
				self.SSAlertService.success("SPA is generated successfully.");
			}
			if(sale.property_settings.otp_spa == "OTP"){
				self.SSAlertService.success("OTP is generated successfully.");
				self.viewOTP();
			}
        });
    }

    getFormattedDate(otp_date) {
        const self = this;

        let otp_utcFormat = null;

        if (otp_date != "" && otp_date != null) {
            var now = new moment();
            var res = otp_date.split("/", 3);
            var otpDate =
                res[2] +
                "-" +
                res[1] +
                "-" +
                res[0] +
                " " +
                now.format("HH:mm:ss");
            var otp_localDate = new Date(self.parseDate(otpDate));
            otp_utcFormat = moment(otp_localDate)
                .utc()
                .format("YYYY-MM-DD HH:mm:ss");
        }

        return otp_utcFormat;
    }

    pushToSendEmailParams(emails_array, obj) {
        obj = [];
        $.each(emails_array, function (index, email_obj) {
            if (email_obj.selected) {
                obj.push(email_obj.email);
            }
        });

        return obj;
    }

    _sendEmail() {
        const self = this;

        let url =
            "sec/developer/sales/" + self.selected_sale.id + "/send-emails";

        let params = {
            saleId: self.selected_sale.id,

            recipients: {
                buyer_emails: [],
                broker_emails: [],
                buyer_lawyer_emails: [],
                developer_emails: [],
                property_lawyer_emails: [],
                teamic_emails: [],
            },
            document_ids: [],
        };

        if (self.email_receipient.buyer) {
            params["recipients"]["buyer_emails"] = self.pushToSendEmailParams(
                self.receipent_data.buyer,
                params["recipients"]["buyer_emails"]
            );
        }

        if (self.email_receipient.agent) {
            params["recipients"]["broker_emails"] = self.pushToSendEmailParams(
                self.receipent_data.agent,
                params["recipients"]["broker_emails"]
            );
        }

        if (self.email_receipient.buyer_lawyer) {
            params["recipients"]["buyer_lawyer_emails"] =
                self.pushToSendEmailParams(
                    self.receipent_data.buyer_lawyer,
                    params["recipients"]["buyer_lawyer_emails"]
                );
        }

        if (self.email_receipient.developer) {
            params["recipients"]["developer_emails"] =
                self.pushToSendEmailParams(
                    self.receipent_data.developer,
                    params["recipients"]["developer_emails"]
                );
        }

        if (self.email_receipient.developer_lawyer) {
            params["recipients"]["property_lawyer_emails"] =
                self.pushToSendEmailParams(
                    self.receipent_data.developer_lawyer,
                    params["recipients"]["property_lawyer_emails"]
                );
        }

        if (self.email_receipient.teamic) {
            params["recipients"]["teamic_emails"] = self.pushToSendEmailParams(
                self.receipent_data.teamic,
                params["recipients"]["teamic_emails"]
            );
        }

        if (self.document_custom == 0) {
            params["document_ids"] = ["auto"];
        } else {
            for (let i = 0; i < self.receipent_data.sendDocuments.length; i++) {
                if (self.receipent_data.sendDocuments[i].selected)
                    params["document_ids"].push(
                        self.receipent_data.sendDocuments[i].id
                    );
            }
        }
        params["document_ids"] = params["document_ids"].join();
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (
                    response.sub_code == 305015 ||
                    response.sub_code == 412002
                ) {
                    self.SSAlertService.danger(
                        "Please Note:",
                        "This sale has been updated by another user. You will not be able to make further updates to this sale."
                    );
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.hideModals();

            self.SSAlertService.success("Send Email successfully.");
        });
    }

    _getEmailData() {
        const self = this;
        let url =
            "sec/developer/sales/" +
            self.selected_sale.id +
            "/get-sale-emails-details";

        let params = {
            saleId: self.selected_sale.id,
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.emailSendingData = response.data;
            self.parseEmailData();
            $("#developerSaleApplicationSendEmailModal").modal("show");
        });
    }

    parseEmailData() {
        const self = this;
        //Documents
        let documents = null;
        let buyer_particular = [];
        let annexes = [];
        let cover_letter = [];
        let pdi = [];
        let otp = [];
        let purchaser_declaration = [];
        let congratulation_letter = [];
        let aml = [];
        let sendDocuments = [];
        let document_ids = [];
        let email_allowed_kinds = [
            self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM,
            self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM,
            self.PROPERTY_DOCUMENT_KIND_PDI_FORM,
            self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
            self.PROPERTY_DOCUMENT_KIND_ANNEXES,
            self.PROPERTY_DOCUMENT_KIND_ANNEX_A,
            self.PROPERTY_DOCUMENT_KIND_ANNEX_B3,
            self.PROPERTY_DOCUMENT_KIND_ANNEX_C,
            self.PROPERTY_DOCUMENT_KIND_OTP,
            self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER,
            self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER,
            self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM,
            self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT,
            self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT, // WEB-4691: Form 1 - Payment Declaration (for Purchaser)
        ];
        documents = _.each(self.emailSendingData.documents, function (ele) {
            if (email_allowed_kinds.includes(ele.document_kind)) {
                if (!ele.document_id) {
                    sendDocuments.push({
                        id: ele.id,
                        name: ele.name,
                        selected: false,
                    });
                } else if (!document_ids.includes(ele.document_id)) {
                    sendDocuments.push({
                        id: ele.id,
                        name: ele.name,
                        selected: false,
                    });
                    document_ids.push(ele.document_id);
                }
            }
        });
        self.receipent_data = {
            buyer: [],
            agent: [],
            developer: [],
            developer_lawyer: [],
            buyer_lawyer: [],
            teamic: [],

            purchaser_declaration: purchaser_declaration,
            buyer_particular: buyer_particular,
            cover_letter: cover_letter,
            pdi: pdi,
            otp: otp,
            congratulation_letter: congratulation_letter,
            annexes: annexes,
            aml: aml,
            sendDocuments: sendDocuments,
        };

        self.prepareReceipientObj(
            self.emailSendingData.recipients.buyer_emails,
            self.receipent_data.buyer
        );
        self.prepareReceipientObj(
            self.emailSendingData.recipients.broker_emails,
            self.receipent_data.agent
        );
        self.prepareReceipientObj(
            self.emailSendingData.recipients.developer_emails,
            self.receipent_data.developer
        );
        self.prepareReceipientObj(
            self.emailSendingData.recipients.property_lawyer_emails,
            self.receipent_data.developer_lawyer
        );
        self.prepareReceipientObj(
            self.emailSendingData.recipients.buyer_lawyer_emails,
            self.receipent_data.buyer_lawyer
        );
        self.prepareReceipientObj(
            self.emailSendingData.recipients.teamic_emails,
            self.receipent_data.teamic
        );
    }

    prepareReceipientObj(emails_array, obj) {
        $.each(emails_array, function (index, email) {
            let buyer_obj = {
                email: email,
                selected: true,
            };
            obj.push(buyer_obj);
        });
    }

    parseDate(date) {
        const self = this;
        const parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
    }

    sendEmail(sale) {
        const self = this;

        self.hideModals();
        //self.resetEmailObject();

        self.show_send_email = true;

        self._getEmailData();
    }

    resetEmailObject() {
        const self = this;

        self.emailSendingData = null;

        self.email_receipient = {
            buyer: true,
            agent: true,
            developer_lawyer: true,
            developer: true,
            buyer_lawyer: true,
            teamic: true,
        };
        self.email_document = {
            buyer_particular: null,
            cover_letter: null,
            otp: null,
            pdi: null,
            purchaser_declaration: null,
            congratulation_letter: null,
            annexes: null,
        };

        self.receipent_data = {};
        self.document_custom = 0;
    }

    viewOTP() {
        const self = this;

        let sale_document = self.selected_sale.documents.filter(
            (x) =>
                x.type === self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED &&
                x.document_kind === self.PROPERTY_DOCUMENT_KIND_OTP
        );

        if (sale_document.length > 0) {
            let url = "sec/assets/presigned-url";
            let params = {
                model: self.ASSET_MODEL_SALE_DOCUMENT,
                id: sale_document[0].id,
            };

            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (
                response
            ) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                // Open OTP in new tab
                window.open(response.data.presigned_url, "_blank");
            });
        }
    }

    prepareSaleStatuses() {
        const self = this;

        self.sale_statuses = [
            {
                id: self.SALE_STATUS_VERIFIED,
                name: "Pending",
            },
            {
                id: self.SALE_STATUS_REJECTED,
                name: "Rejected",
            },
            {
                id: self.SALE_STATUS_APPROVED,
                name: "Approved",
            },
        ];

        self.$timeout(function () {
            $("select.dashboard-select#status-select").niceSelect("update");
        });
    }

    /**
     * Acquire the review lock on a sale, then open the Sale Review page.
     *
     * @remarks
     * WEB-4375: migrated to the unified `sec/locks/acquire`. The lock is not
     * released here — the review page re-acquires the same lock on load and
     * owns it from then on.
     *
     * @param {Object} sale Sale row from the applications listing.
     * @returns {void}
     */
    onReview(sale) {
        const self = this;

        self.acquireReviewLock(sale, 0);
    }

    /**
     * Acquire the review lock and open the Sale Review page on success.
     *
     * @remarks
     * When the sale is held by another user the same confirmation as before
     * is shown, but confirming now re-acquires with `override: 1`. The legacy
     * endpoints had no override, so the "yes" path used to open the review
     * page with no lock at all.
     *
     * @param {Object} sale     Sale row from the applications listing.
     * @param {number} override 1 to force-release a lock held by another user.
     * @returns {void}
     */
    acquireReviewLock(sale, override) {
        const self = this;

        loading(true);
        self.SSLockService.acquire(
            self.SSLockService.ENTITY_TYPE_SALE,
            sale.id,
            self.LOCK_TYPE_SALE_APPLICATION_REVIEW,
            {override: override}
        ).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == self.SSLockService.SUB_CODE_LOCK_CONFLICT) {
                    self.SSConfirmationService.getConfirmed(
                        "Error!",
                        "This sale is being assessed by " +
                            self.SSLockService.getLockingUserName(response) +
                            ", are you sure you want to proceed?",
                        self.SSConfirmationService.TYPE_DEFAULT,
                        function () {
                            // Take the lock off the other user, then continue.
                            self.acquireReviewLock(sale, 1);
                        }
                    );
                } else if (response.sub_code == 305024) {
                    // The unified endpoint returns 305024 for every status
                    // that is not VERIFIED, not just "already approved".
                    self.SSAlertService.danger(
                        "Error!",
                        "This sale is not pending review."
                    );
                } else if (response.sub_code == 305010) {
                    self.SSAlertService.danger("Error!", "Cannot find sale.");
                } else {
                    self.SSAlertService.parseAndDisplayServerError(response);
                }

                return;
            }

            self.proceedToReviewPage(sale.id);
        });
    }

    proceedToReviewPage(sale_id) {
        const self = this;

        self.$window.location.href =
            "/developer/sales/applications/review?sale_id=" +
            sale_id +
            "&id=" +
            self.current;
    }

    onAccept(sale) {
        const self = this;

        self.hideModals();

        self.showAccept = true;
        $("#developerSaleApplicationAcceptModal").modal("show");
    }

    onReject(sale) {
        const self = this;

        self.hideModals();

        self.showReject = true;
        $("#developerSaleApplicationRejectModal").modal("show");
    }

    hideModals() {
        const self = this;

        self.showReview = false;
        self.showAccept = false;
        self.showExport = false;
        self.showReject = false;
        self.showAgent = false;
        self.showBuyer = false;
        self.showOTPModal = false;
        self.show_send_email = false;

        if ($("#developerSaleApplicationReviewModal").is(":visible"))
            $("#developerSaleApplicationReviewModal").modal("hide");
        if ($("#developerSaleApplicationAcceptModal").is(":visible"))
            $("#developerSaleApplicationAcceptModal").modal("hide");
        if ($("#developerSaleApplicationExportModal").is(":visible"))
            $("#developerSaleApplicationExportModal").modal("hide");
        if ($("#developerSaleApplicationRejectModal").is(":visible"))
            $("#developerSaleApplicationRejectModal").modal("hide");
        if ($("#developerSaleApplicationAgentModal").is(":visible"))
            $("#developerSaleApplicationAgentModal").modal("hide");
        if ($("#developerSaleApplicationBuyerModal").is(":visible"))
            $("#developerSaleApplicationBuyerModal").modal("hide");
        if ($("#developerSaleApplicationOTPModal").is(":visible"))
            $("#developerSaleApplicationOTPModal").modal("hide");
        if ($("#developerSaleApplicationGenerateOTPModal").is(":visible"))
            $("#developerSaleApplicationGenerateOTPModal").modal("hide");
        if ($("#developerSaleApplicationReGenerateOTPModal").is(":visible"))
            $("#developerSaleApplicationReGenerateOTPModal").modal("hide");
        if ($("#developerSaleApplicationSendEmailModal").is(":visible"))
            $("#developerSaleApplicationSendEmailModal").modal("hide");
        if ($("#paymentDetailsInfo").is('visible')) 
            $('#paymentDetailsInfo').modal('hide');
        
    }

    previousPage() {
        const self = this;

        self.offset = self.offset - parseInt(self.limit);
        self.retrieveApplications();
    }

    nextPage() {
        const self = this;

        self.offset = self.offset + parseInt(self.limit);
        self.retrieveApplications();
    }

    updateFilter() {
        const self = this;
        var query_string = null;

        if (self.property_id || self.property_id == "") {
            sessionStorage.setItem("property_id_filter", self.property_id);
        }
        if (self.property_id == null) {
            sessionStorage.setItem("property_id_filter", "");
        }
        if (self.sale_status || self.sale_status == "") {
            sessionStorage.setItem("sale_status_filter", self.sale_status);
        }
        if (self.price || self.price == "") {
            sessionStorage.setItem("price_filter", self.price);
        }
        if (self.agency || self.agency == "") {
            sessionStorage.setItem("agency_filter", self.agency);
        }

        if (self.broker || self.broker == "") {
            sessionStorage.setItem("broker_filter", self.broker);
        }

        if (self.buyer || self.buyer == "") {
            sessionStorage.setItem("buyer_filter", self.buyer);
        }

        if (self.search_by || self.search_by == "") {
            sessionStorage.setItem("search_by_filter", self.search_by);
        }

        if (self.search_value || self.search_value == "") {
            sessionStorage.setItem("search_value_filter", self.search_value);
        }

        if (self.sortColumn || self.sortColumn == "") {
            sessionStorage.setItem("sort_column_filter", self.sortColumn);
        }

        if (self.sortOrder || self.sortOrder == "") {
            sessionStorage.setItem("sort_order_filter", self.sortOrder);
        }

        if (self.limit || self.limit == "") {
            sessionStorage.setItem("limit_filter", self.limit);
        }

        self.offset = 0;
        self.retrieveApplications();
    }

    // onViewSummary(sale) {
    //     const self = this;

    //     self.$window.location.href =
    //         "/developer/sales/applications/summary?sale_id=" +
    //         sale.id +
    //         "&id=" +
    //         self.current;
    // }

    onViewSummary(sale,expandPaymentDetails = false) {
        const self = this;
        let url = "";
        if(expandPaymentDetails){
            url = '/developer/sales/payments/'+ sale.id + '/details?div=paymentInformation';
        }else{
            url = '/developer/sales/payments/'+ sale.id + '/details/';
        }
        ($("#paymentDetailsInfo").modal('show'));
        self.$timeout(function() {
            self.$window.open(url, '_blank');
        }, 2*1000);
    }

    /**
     * Sale statuses the listing shows for the selected status filter.
     *
     * @returns {string} Comma-separated status ids, as sent to `sec/developer/sales`.
     * @remarks WEB-4686: shared by the list load and the change-feed handler, which
     *          needs the same set to tell whether a changed sale belongs on the page.
     */
    getStatusFilter() {
        const self = this;

        let status = self.sale_status;

        if (self.sale_status == "" || self.sale_status == null) {
            status =
                self.SALE_STATUS_VERIFIED +
                "," +
                self.SALE_STATUS_REJECTED +
                "," +
                self.SALE_STATUS_OTP +
                "," +
                self.SALE_STATUS_APPROVED;
        } else if (self.sale_status == self.SALE_STATUS_APPROVED) {
            status = self.SALE_STATUS_OTP + "," + self.SALE_STATUS_APPROVED;
        }

        return String(status);
    }

    /**
     * Load the current page of the listing.
     *
     * @param {number}  [page]              Page to load; omitted keeps the current offset.
     * @param {boolean} [show_loading=true] False for a silent refresh (change feed): no
     *                                      spinner and the alert box is left alone.
     * @returns {void}
     * @remarks WEB-4686: the list used to re-request itself every 10 s with
     *          `response_md5`, which still made the server build the full page before it
     *          could answer "unchanged" — and every call scheduled another such loop, so
     *          loops stacked up with each filter / page change. Freshness now comes from
     *          the sales change feed (see {@link applySaleChanges}); this method only
     *          loads the list. The feed is re-baselined BEFORE the list read so a change
     *          landing between the two is picked up by the next poll.
     */
    retrieveApplications(page, show_loading = true) {
        const self = this;

        if (show_loading) {
            self.SSAlertService.message = null;
        }

        let status = self.getStatusFilter();

        if (page) {
            self.offset = page * self.limit - self.limit;
        }

        if (page) {
            self.current = page;
        }

        var limit = sessionStorage.getItem("limit_filter");

        if (limit && limit != "" && limit != null) {
            self.limit = limit;
        }

        let url = "sec/developer/sales";
        let params = {
            property_id: self.property_id,
            status: status,
            limit: self.limit,
            offset: self.offset,
            include: self.SALES_LIST_INCLUDE,
            send_total_count: true,
            price: self.price,
            agency: self.agency,
            broker: self.broker,
            buyer: self.buyer,
        };

        params.order = {};
        params.order[self.sortColumn] = self.sortOrder;

        if (self.search_value) {
            params[self.search_by] = self.search_value;
        }

        // Only the latest request may fill the table — a silent refresh and a
        // user-triggered load can overlap.
        const request_id = ++self.list_request_id;

        if (show_loading) {
            loading(true);
        }
        self.saleChangePoller.rebase().then(function () {
            return self.SSHttpService.getAPIRequest(url, params);
        }).then(function (response) {
            if (show_loading) {
                loading(false);
            }

            if (request_id !== self.list_request_id) {
                return;
            }

            if (response instanceof Error) {
                if (show_loading) {
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }

            self.sales = self.processSales(response.data.sales, response.data);
            self.sales_total = response.data.total_count;
        });
    }

    /**
     * Prepare listing rows for display, dropping the originals of re-issued sales.
     *
     * @param {Array}  sales  Rows from `sec/developer/sales` (or the change feed).
     * @param {Object} data   The response `data` — the side arrays (eois, units,
     *                        brokers, agencies, properties, payment_plans) the rows
     *                        are joined with.
     * @returns {Array} The prepared rows.
     */
    processSales(sales, data) {
        const self = this;

        if (!sales) {
            return sales;
        }

        let reissued_sales = [];

        //Process broker and agency
        $.each(data.brokers, function (index, broker) {
            broker["agency"] = data.agencies.find(
                (x) => x.id === broker.agency_id
            );
        });

        jQuery.each(sales, function (i, sale) {
            // Check if sale is re-issued
            if (sale.reissued_from_sale_id) {
                reissued_sales.push(sale);
            }
            self.processSale(sale, data);
        });

        // If sale is re-issued then remove original record
        try {
            if (reissued_sales && reissued_sales.length > 0) {
                let temp_sales = [];

                jQuery.each(sales, function (index, sale) {
                    let sale_reissue = reissued_sales.find(
                        (x) => x.reissued_from_sale_id == sale.id
                    );

                    if (!sale_reissue) {
                        temp_sales.push(sale);
                    }
                });

                sales = temp_sales;
            }
        } catch (ex) {
            console.log(ex);
        }

        return sales;
    }

    /**
     * Prepare one listing row: AML / risk assessment fields, property settings,
     * status label, main broker, buyers, EOI, unit, booking fee and project name.
     *
     * @param {Object} sale  A row from `sec/developer/sales` or the change feed.
     * @param {Object} data  The response `data` holding the side arrays.
     * @returns {void}
     * @remarks WEB-4686: lifted out of retrieveApplications() unchanged so a row the
     *          change feed returns is prepared exactly like the list's own row.
     *          Expects data.brokers to have their `agency` attached already
     *          ({@link processSales} does it).
     */
    processSale(sale, data) {
        const self = this;

        sale.aml = sale.aml ? JSON.parse(sale.aml) : null;

        // Filter Marker Questions
        if(sale.question_answers){
            $.each(sale.question_answers, function(i, answer){
                if(self.SSUtilService.compareQuestionMarker(answer.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL)){
                    sale.risk_assessment_level = answer.answer_text;
                }
                if(self.SSUtilService.compareQuestionMarker(answer.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS)){
                    sale.risk_assessment_remarks = answer.answer_text;
                }
                if(self.SSUtilService.compareQuestionMarker(answer.marker, self.QUESTION_MARKER_SPECIAL_CONDITIONS)){
                    sale.special_conditions = answer.answer_text;
                }
            });
        }

        var sale_property = data.properties
            ? data.properties.find(
                  (x) => x.id == sale.property_id
              )
            : null;
        if (sale_property) {

        sale.property = sale_property;

            if (
                sale_property.settings &&
                sale_property.settings.length > 0
            ) {
                let sale_property_setting =
                    sale_property.settings.find(
                        (x) => x.name == "otp_spa"
                    );
                if (!sale.hasOwnProperty("property_settings")) {
                    sale["property_settings"] = {};
                }
                sale.property_settings["otp_spa"] =
                    sale_property_setting
                        ? sale_property_setting.value
                        : "OTP";
            }
        }

        let paymentPlans = data.payment_plans;

        sale.payment_plan_name = "--";
        if (paymentPlans && paymentPlans.length) {
            let selectedPaymentPlan = paymentPlans.find(
                (x) => x.id == sale.payment_plan_id
            );
            if (selectedPaymentPlan) {
                sale.payment_plan_name = selectedPaymentPlan.name;
            }
        }

        if (sale.status == self.SALE_STATUS_VERIFIED) {
            sale.status_name = "Pending";
        }
        if (sale.status == self.SALE_STATUS_APPROVED) {
            sale.status_name = "Approved";
        }
        if (sale.status == self.SALE_STATUS_OTP) {
            sale.status_name = "Approved";
        }
        if (sale.status == self.SALE_STATUS_REJECTED) {
            sale.status_name = "Rejected";
        }

        /** WEB-3000 Web: AMS/DMS - Showing incorrect agent name
         * If sale has brokers, Check for Buyer Agent(MAIN_BROKER) and set as main broker against sale
         * If Main Broker (Buyer Agent) not found, set Sale Consultant as main_broker
         * If Sale Consultant not found, set Team IC as main_broker **/
        if(data.brokers && data.brokers.length > 0 && sale.brokers){
            let main_broker_user_id = null;
            if(sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_MAIN_BROKER)){ // Check sale has Buyer Agent(MAIN_BROKER)
                main_broker_user_id = sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_MAIN_BROKER).broker_user_id;
            } else if(sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_SALES_CONSULTANT)){ // Check sale has Sale Consultant
                main_broker_user_id = sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_SALES_CONSULTANT).broker_user_id;
            } else if(sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_TEAMLEAD)){ // Check sale has Team Lead
                main_broker_user_id = sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_TEAMLEAD).broker_user_id;
            }

            sale['main_broker'] = data.brokers.find(x => x.user_id === main_broker_user_id);
        }

        sale["buyers"] = [];

        if (sale.sale_gst_detail) {
            sale.gst_percent = sale.sale_gst_detail.gst_percent;
        }

        $.each(sale.sale_buyers, function (index, buyer) {
            let processed_buyer = JSON.parse(buyer.data);
            sale["buyers"].push(processed_buyer);
        });

        $.each(sale.history, function (index, list) {
            if (list.status == self.SALE_STATUS_VERIFIED) {
                sale["application_verified_date"] = list.created_at;
            }
        });

        sale["eoi"] = data.eois.find(
            (x) => x.id === sale.eoi_id
        );
        sale["unit"] = data.units.find(
            (x) => x.id === sale.unit_id
        );

        // https://showsuite.atlassian.net/browse/WEB-2200
        // Booking Fee Calculation as per Selected Payment Plan
        try {
            if (sale.payment_plan_id && data.payment_plans) {
                let payment_plan = data.payment_plans.find(
                    (x) => x.id == sale.payment_plan_id
                );

                if (payment_plan) {
                    let clause = payment_plan.payment_plan_clauses.find(
                        (x) =>
                            x.payment_type ==
                            self.PAYMENT_TYPE_01_BOOKING_FEE
                    );

                    if (clause && clause.amount_percentage) {
                        self.booking_fee_percentage =
                            clause.amount_percentage;
                    }
                }
            }
        } catch (ex) {
            console.log(ex);
        }

        var property = self.properties
            ? self.properties.find(
                  (x) => x.id === sale.unit.property_id
              )
            : null;
        if (property) {
            sale.property_name = property.name;
            sale.property_short_code = property.short_code;
        }
    }

    /**
     * Apply one answer of the sales change feed to the listing.
     *
     * @param {Object} data  `sec/developer/sales/changes` response data.
     * @returns {void}
     * @remarks WEB-4686. Rows on the current page that changed are swapped in place
     *          (`angular.copy` into the existing object keeps the row's DOM, the
     *          scroll position and any `selected_sale` reference). The current page is
     *          silently re-fetched — page, filters, search and sort kept — only when
     *          its membership may have changed: a sale on it left the page or the
     *          status filter, a changed sale elsewhere now matches the filter, or the
     *          server asked for a full reload. If a popup is open for a sale another
     *          user just changed, it is closed and the user told who changed it, so
     *          no action runs on stale data.
     */
    applySaleChanges(data) {
        const self = this;

        if (data.full_reload_required) {
            self.retrieveApplications(self.current, false);
            return;
        }

        if (!(data.changes && data.changes.length)) {
            return;
        }

        const status_filter = self.getStatusFilter().split(",").map(Number);
        const rows = self.processSales(data.sales || [], data) || [];
        const open_sale = self.SSSaleChangeFeedService.findOpenPopupSale(self.getSalePopups());
        let reload = false;
        let open_sale_change = null;

        jQuery.each(data.changes, function (i, change) {
            const current = (self.sales || []).find((x) => x.id == change.sale_id);

            if (!current) {
                // Not on this page: it may belong here now (e.g. a sale just verified).
                if (change.listed && status_filter.indexOf(Number(change.status)) !== -1) {
                    reload = true;
                }
                return;
            }

            // The server re-reads 15 s before `since`: skip a change already shown.
            if (!self.SSSaleChangeFeedService.isNewerThanRow(change, current)) {
                return;
            }

            if (open_sale && open_sale.id == change.sale_id
                && self.SSSaleChangeFeedService.isByAnotherUser(change)) {
                open_sale_change = change;
            }

            const row = rows.find((x) => x.id == change.sale_id);
            if (!row || status_filter.indexOf(Number(row.status)) === -1) {
                // Left the page (Returned, deleted, re-issued…) or the status filter.
                reload = true;
                return;
            }

            angular.copy(row, current);
        });

        if (open_sale_change) {
            self.releaseGenerateOTPLock("Sale updated by another user");
            self.hideModals();
            self.SSAlertService.warning(
                "Sale updated",
                "This sale was updated by " +
                    self.SSSaleChangeFeedService.describeChange(open_sale_change) +
                    ". Its details have been refreshed — please review them before continuing."
            );
        }

        if (reload) {
            self.retrieveApplications(self.current, false);
        }
    }

    /**
     * Popups of this page that act on one sale, with the sale each one acts on.
     *
     * @returns {Array<{id: string, sale: Function}>}
     */
    getSalePopups() {
        const self = this;

        const selected = function () {
            return self.selected_sale;
        };
        const current = function () {
            return self.currentSale || self.selected_sale;
        };

        return [
            {id: "#developerSaleApplicationAcceptModal", sale: selected},
            {id: "#developerSaleApplicationRejectModal", sale: selected},
            {id: "#developerSaleApplicationOTPModal", sale: selected},
            {id: "#developerSaleApplicationSendEmailModal", sale: selected},
            {id: "#developerSaleApplicationGenerateOTPModal", sale: current},
            {id: "#developerSaleApplicationReGenerateOTPModal", sale: current},
            {id: "#developerSaleApplicationBookingfeeAlertModal", sale: current},
        ];
    }

    viewRiskAssessmentRemarks(sale){
        const self = this;

        if(!(sale && sale.risk_assessment_remarks)) return;

        self.SSConfirmationService.getConfirmed(
            "Remarks",
            sale.risk_assessment_remarks,
            self.SSConfirmationService.TYPE_OK,
            function () {
                // 
            }
        );
    }

    showBrokerModal(brokers) {
        const self = this;
        self.hideModals();

        self.agentIndex = 0;
        self.agentModalData = [];

        self.agentRoles = {};

        jQuery.each(brokers, function (i, agent) {
            self.agentRoles[agent.broker_user_id] = agent.broker_role;
            let url = "brokers/" + agent.broker_user_id;
            let param = {
                include: "user, agency",
            };
            loading(true);
            self.SSHttpService.getAPIRequest(url, param).then(function (
                response
            ) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                let broker = response.data.brokers[0];
                broker["broker_role"] = self.SSUtilService.getBrokerRole(
                    self.agentRoles[broker.user_id]
                );
                self.agentModalData.push(broker);
            });
        });

        self.showAgent = true;
        $("#developerSaleApplicationAgentModal").modal("show");
    }

    getPreviousAgent() {
        const self = this;

        if (self.agentIndex > 0) {
            let index = self.agentIndex - 1;
            self.agentIndex = index;
        }
    }

    getNextAgent() {
        const self = this;

        if (self.agentIndex < self.agentModalData.length - 1) {
            let index = self.agentIndex + 1;
            self.agentIndex = index;
        }
    }

    showBuyersModal(buyers) {
        const self = this;
        self.hideModals();

        self.showBuyer = true;
        self.selected_buyers = buyers;
        $("#developerSaleApplicationBuyerModal").modal("show");
    }

    getDeveloperUsers() {
        const self = this;

        let url = "sec/developer/users";
		let params = {
			status: 1,
			limit: 50,
            include_me: 1
		}

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (response.data && response.data.users) {
				self.developer_users = response.data.users;

            }
        });
    }

    getMarketingSchemeName(marketingScheme){
        const self = this;
        if(!marketingScheme) return;
        let name = self.SSConfigService.searchArray("marketing_schemes", marketingScheme);
        if(name) {
            name = "(" + name + ")";
        }
        return name;
    }

    savePropertyIdLocalStorage(){
        const self = this;
        self.SSUtilService.saveToLocalStorage("lastPropertyId", self.property_id);
    }
}

SalesApplicationController.$inject = [
    "$scope",
    "$window",
    "$filter",
    "SSUserService",
    "SSAppService",
    "SSHttpService",
    "SSUtilService",
    "SSDateService",
    "SSAlertService",
    "$timeout",
    "SSConfigService",
    "NgTableParams",
    "SSConfirmationService",
    "SSAnalyticsService",
    "SSLockService",
    "SSSaleChangeFeedService"
];
app.controller("SalesApplicationController", SalesApplicationController);